/**
 * The FlashBook studio's autosave status line.
 *
 * The line itself is the shared one (`#/components/studio/StudioAutosaveNote`),
 * which the Capsule studio draws too — it is the same sentence about the same kind
 * of copy. This wrapper exists only to hold the id the book studio's suites address
 * it by.
 */
import {StudioAutosaveNote} from '#/components/studio/StudioAutosaveNote'
import {type AutosaveState} from '#/components/studio/useStudioAutosave'

export function FlashBookAutosaveNote({state}: {state: AutosaveState}) {
  return <StudioAutosaveNote state={state} testID="flashBookAutosaveNote" />
}
